import { Component, OnInit } from '@angular/core';
import { GlobalToastService } from '../_services/global-toast.service';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.css']
})
export class ToastComponent implements OnInit {

  constructor(private toastService: GlobalToastService) { }

  ngOnInit() {
  }

}
